import React, { useState } from "react";

export default function CourseManagement() {
  const [courses, setCourses] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    difficulty: "Easy",
    duration: "",
    dueType: "fixed",
    dueDate: "",
    dueDays: 14,
    visible: true,
    groups: "",
    image: "",
    scorm: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFile = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;
    setFormData({ ...formData, [field]: file.name }); // Stub logic
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCourses([...courses, { ...formData }]);
    alert("Course saved (simulation only)");
    setFormData({
      title: "",
      description: "",
      difficulty: "Easy",
      duration: "",
      dueType: "fixed",
      dueDate: "",
      dueDays: 14,
      visible: true,
      groups: "",
      image: "",
      scorm: "",
    });
  };

  return (
    <div className="space-y-8">
      <h2 className="text-xl font-bold">Course Management</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded shadow border max-w-3xl">
        <h3 className="text-lg font-semibold">Create New Course</h3>

        <input type="text" name="title" placeholder="Course Title" required value={formData.title} onChange={handleChange} className="border px-3 py-2 rounded w-full" />
        <textarea name="description" placeholder="Short Description" value={formData.description} onChange={handleChange} className="border px-3 py-2 rounded w-full" />

        <div className="flex gap-4">
          <select name="difficulty" value={formData.difficulty} onChange={handleChange} className="border px-3 py-2 rounded w-1/2">
            <option value="Easy">Easy</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Hard">Hard</option>
          </select>
          <input type="number" name="duration" value={formData.duration} onChange={handleChange} placeholder="Duration (mins)" className="border px-3 py-2 rounded w-1/2" />
        </div>

        <div>
          <label className="font-medium block mb-1">Due Date Type</label>
          <div className="flex gap-6">
            <label>
              <input type="radio" name="dueType" value="fixed" checked={formData.dueType === "fixed"} onChange={handleChange} /> Fixed Date
            </label>
            <label>
              <input type="radio" name="dueType" value="dynamic" checked={formData.dueType === "dynamic"} onChange={handleChange} /> X Days From Assignment
            </label>
          </div>
          {formData.dueType === "fixed" ? (
            <input type="date" name="dueDate" value={formData.dueDate} onChange={handleChange} className="mt-2 border px-3 py-2 rounded w-full" />
          ) : (
            <input type="number" name="dueDays" value={formData.dueDays} onChange={handleChange} className="mt-2 border px-3 py-2 rounded w-full" />
          )}
        </div>

        <div className="flex items-center gap-3">
          <input type="checkbox" name="visible" checked={formData.visible} onChange={handleChange} />
          <label>Show in Course Catalog</label>
        </div>

        <input type="text" name="groups" value={formData.groups} onChange={handleChange} placeholder="Restrict to Groups (comma separated)" className="border px-3 py-2 rounded w-full" />

        <div className="space-y-2">
          <label className="font-medium">Course Image</label>
          <input type="file" accept="image/*" onChange={(e) => handleFile(e, "image")} />
          {formData.image && <p className="text-xs text-gray-500">Selected: {formData.image}</p>}
        </div>

        <div className="space-y-2">
          <label className="font-medium">Upload SCORM Package</label>
          <input type="file" accept=".zip" onChange={(e) => handleFile(e, "scorm")} />
          {formData.scorm && <p className="text-xs text-gray-500">Selected: {formData.scorm}</p>}
        </div>

        <button type="submit" className="bg-gray-800 text-white px-5 py-2 rounded">
          Save Course
        </button>
      </form>

      {/* List */}
      <div className="bg-white p-4 rounded shadow border">
        <h3 className="text-lg font-semibold mb-2">Courses</h3>
        <ul className="space-y-2 text-sm">
          {courses.map((c, idx) => (
            <li key={idx} className="border p-2 rounded flex justify-between items-center">
              <span>{c.title}</span>
              <span className="text-gray-400 text-xs">{c.difficulty} – {c.duration} min</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
